import { styled } from "@styles";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;
export const SelectIndicator = styled.div`
  margin: 0 1rem 0 0;
  cursor: pointer;
`;
